import React from 'react';
import { AppContextInterface, AppContext } from '../app-context-provider';
import Img from '../components/Img';

class MainLogo extends React.Component {
  static contextType = AppContext;
  context!: AppContextInterface;

  render() {
    let LogoUrl = this.context.pageData?.mainLogo?.file?.url;
    return (
      <div className='main-logo'>
        <Img src={LogoUrl} alt='Main logo for customer' />
      </div>
    );
  }
}

export default MainLogo;
